import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import { RiCheckLine } from 'react-icons/ri';

import styles from './index.module.scss';

const cx = classNames.bind(styles);

const Checkbox = ({ checked, size = 14, onClick }) => {
  return (
    <div className={cx('container')} style={{ width: size, height: size }} onClick={onClick}>
      {checked && <RiCheckLine size={size} color="white" />}
    </div>
  );
};

Checkbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  size: PropTypes.number,
  onClick: PropTypes.func,
};

export default Checkbox;
